/* 学生管理API */

import {
  GET,
  GETNEW,
  POST,
  PUT,
  PUTNEW,
  POSTNEW,
  DELETEBODY,
  DELETEBODYNEW,
  DELETENEW,
  download,
  POSTFormData,
  EXPORT,
  EXPORTNEW,
  POSTFormDataNEW
} from '@/request/http'

//  UI改版
//  获取学生管理默认表头
export const getStudentDefaultColunm = p => GET('/studentv2/archives-config/default/list-field', p, 4)
//  获取学生管理默认表头
export const getStudentAllColunm = p => GET('/studentv2/archives-config/all/list-field', p, 4)
//  分页查询学生
export const getStudentInfo = p => POST('/studentv2/archives/page', p, 4)
//  学生档案
export const getStudentArchives = p => GET('/studentv2/archives/get/{studentId}', p, 4)
//  根据学号获取学生信息（带权限）
export const studentNoGetStudentInfoIsLimit = p => GET('/studentv2/basic-info/getByStudentNo', p, 4)
//  获取辅导员ID
export const getNewClassCounselorId = p => GETNEW('/counselor/counselor-info/getByUserId', p, 4)
//  获取专业班级
export const getCollegeSystem = p => GET('/studentv2/faculty/tree/fac-maj-cla', p, 4)
//  获取学院专业
export const getCollegeMajor = p => GET('/studentv2/faculty/tree/fac-maj', p, 4)
//  添加学生模块查询列表(必须有条件)
export const getStudentsInfoByParam = p => POST('/studentv2/basic-info/findPage', p, 4)
//  添加学生模块查询列表(查询所有学生)
export const getAllStudentsInfoByParam = p => POST('/studentv2/basic-info/findCounselorPage', p, 4)
//  新生分班辅导员查询新建班级
export const getNewStudentBandingClassList = p => POSTNEW('/studentv2/class/counselor/list', p, 4)
//  新生分班辅导员查询负责专业
export const getNewStudentBandingMajorList = p => GETNEW('/studentv2/orientation/getMajorList', p, 4)
//  添加学生
export const addStudents = p => POST('/studentv2/basic-info/bind-class', p, 4)
//  批量添加学生信息模板下载
export const getAddStudentTemplate = p => GETNEW('/studentv2/template/get', p, 4)
//  学生信息导出
export const exportStudentInfo = p => EXPORT('/studentv2/archives/export', p, 4)
//  学生信息导出
export const deleteStudentNew = p => POST('/studentv2/basic-info/unbind/class', p, 4)
//  新增学生
export const newStudent = p => POST('/studentv2/basic-info/add', p, 4)
//  编辑学生
export const editStudentInfo = p => POSTNEW('/studentv2/basic-info/update', p, 4)
//  学院编辑学生（新增）
export const editStudentInfoFaculty = p => POSTNEW('/studentv2/basic-info/updateCounselor', p, 4)
//  查询学生信息（编辑学生时使用）
export const getEditStudentInfo = p => GET('/studentv2/basic-info/get', p, 4)
//  导入学生信息
export const importStudentsInfo = p => POSTNEW('/studentv2/basic-info/importBasicInfo', p, 4)
//  获取辅导员
export const getInstructorInfoList = p => POSTNEW('/counselor/counselor-info/findList/groupbyfac', p, 5)
//  获取冲突分页查询
export const getHealthErrorList = p => POSTNEW('/studentv2/qr-code-query/page', p, 5)
//  下载档案审查PDF
export const downloadGraduateArchivesPDF = p => POSTNEW('/studentv2/graduate-barcode/createPdf', p)
//  批量下载档案审查PDF
export const bathDownloadArchivesPDF = p => POSTNEW('/studentv2/graduate-record/batchDownloadPdf', p)

//  少数学生管理-分页查询
export const getMinorityInfo = p => POST('/studentv2/minority/page', p, 4)
//  少数学生管理-移除学生
export const removeStudent = p => POST('/studentv2/minority/remove', p, 4)
//  少数学生管理-添加学生查询
export const querytStudentToLess = p => POST('/studentv2/minority/findWaitAddPage', p, 4)
//  少数学生管理-添加学生
export const newLessStudent = p => POST('/studentv2/minority/add', p, 4)
//  少数民族学生信息导出
export const exportLessStudentInfo = p => EXPORT('/studentv2/minority/export', p, 4)
//  少数民族学生信息导入
export const importantLessStudentInfo = p => POSTFormData('/studentv2/minority/importBasicInfo', p, 4)

//  分页查询班级
export const queryClassList = p => POST('/studentv2/class/page', p, 4)
//  学院划分虚拟班级
export const divideVirtuallyClass = p => POSTNEW('/studentv2/basic-info/bindVirtuallyClass', p, 4)
//  新增班级
export const newClass = p => POSTNEW('/studentv2/class/save', p, 4)
// 按学院获取辅导员
export const getCounselorList = p => POST('/counselor/counselor-info/findList/groupbyfac', p, 4)
// 删除班级
export const removeClass = p => DELETEBODYNEW('/studentv2/class/remove', p, 4)
// 修改班级
export const editClass = p => PUTNEW('/studentv2/class/update', p, 4)
// 毕业生管理
// 创建及编辑毕业生档案核查计划接口（辅导员）
export const saveAndEditGaPlan = p => POSTNEW('/studentv2/graduate-plan/save', p, 4)
// 计划分页查询接口（辅导员）
export const getGaPlanList = p => POSTNEW('/studentv2/graduate-plan/page', p, 4)
// 修改学生延毕状态
export const updateGAStudentType = p => POSTNEW('/studentv2/graduate-record/updateStudentType', p, 4)
// 删除学生审查记录
export const deleteGAStudent = p => POSTNEW('/studentv2/graduate-record/deleteByStudentId', p, 4)
// 毕业档案记录查询分页接口
export const getGaStudentList = p => POSTNEW('/studentv2/graduate-record/page', p, 4)
// 获取审核项
export const getReviewItems = p => GETNEW('/studentv2/graduate-record/get-info', p, 4)
// 毕业档案记录查询分页接口
export const submitReviewItems = p => POSTNEW('/studentv2/graduate-record/save', p, 4)
// 毕业档案记录统计
export const getGaStatistics = p => GETNEW('/studentv2/graduate-plan/statistics', p, 4)
// 毕业档案记录查询分页接口
export const saveGraduateMail = p => POSTNEW('/studentv2/graduate-mail/save', p, 4)
// 邮寄地址-导入接口
export const importMailAddress = p => POSTFormData('/studentv2/graduate-mail/import', p, 4)
// 毕业档案记录明细导出接口
export const exportStudentArchives = p => EXPORTNEW('/studentv2/graduate-record/export', p, 4)
// 毕业档案记录统计
export const getGaQrCode = p => GETNEW('/studentv2/graduate-barcode/get/address', p, 4)
// 毕业档案邮寄单导出接口
export const exportStudentMail = p => EXPORTNEW('/studentv2/graduate-mail/exportAppOrder', p, 4)


// 新增班级
export const editStudentStatus = p => POSTNEW('/studentv2/basic-info/update/student-status', p, 4)

// 学位管理
// 学位查询
export const getStudentDegreeList = p => GETNEW('/studentv2/degree/list', p, 4)
// 新增学位
export const addOneStudentDegree = p => POST('/studentv2/degree/save', p, 4)
// 编辑学位
export const editOneStudentDegree = p => PUT('/studentv2/degree/update', p, 4)
// 删除学位
export const delOneStudentDegree = p => DELETEBODY('/studentv2/degree/remove', p, 4)
// 根据id查询学位
export const getStudentDegreeById = p => GET('/studentv2/degree/get', p, 4)
// 分页查询学位列表
export const getStudentDegreeListPage = p => GET('/studentv2/degree/page', p, 4)

// 院系管理
//  院系查询
export const getStudentCollegeList = p => GET('/studentv2/faculty/list', p, 4)
// 新增院系
export const addStudentCollege = p => POST('/studentv2/faculty/save', p, 4)
//编辑院系
export const editStudentCollege = p => POST('/studentv2/faculty/update', p, 4)
//删除院系
export const deleteStudentCollege = p => POST('/studentv2/faculty/remove', p, 4)
//根据id查询学院
export const getStudentCollegeById = p => GET('/studentv2/faculty/get', p, 4)
// 分页查询学院列表
export const getStudentCollegeListPage = p => GET('/studentv2/faculty/page', p, 4)

// 专业管理
//  专业查询
export const getStudentMajorList = p => GET('/studentv2/major/list', p, 4)
// 新增专业
export const addOneStudentMajor = p => POST('/studentv2/major/save', p, 4)
// 编辑专业
export const editOneStudentMajor = p => PUT('/studentv2/major/update', p, 4)
// 删除专业
export const deleteOneStudentMajor = p => DELETEBODY('/studentv2/major/remove', p, 4)
// 根据id查询专业
export const getStudentMajorById = p => GET('/studentv2/major/get', p, 4)
// 分页查询学院专业
export const getStudentMajorListPage = p => GET('/studentv2/major/page', p, 4)

// 班级管理
//  班级查询
export const getStudentClassesList = p => GET('/studentv2/class/list', p, 4)
// 新增班级
export const addStudentClasses = p => POST('/studentv2/class/save', p, 4)
// 编辑班级
export const editStudentClasses = p => PUT('/studentv2/class/update', p, 4)
// 删除班级
export const deleteStudentClasses = p => DELETEBODY('/studentv2/class/remove', p, 4)
// 根据id查询班级
export const getStudentClassesById = p => GET('/studentv2/class/get', p, 4)
// 分页查询学院班级
export const getStudentClassesListPage = p => GET('/studentv2/class/page', p, 4)

// 学生管理
//  学生查询
//  export const getStudentList = p => GET('/studentv2/class/getList' , p, 4);
// 新增学生
export const addOneStudent = p => POST('/studentv2/save', p, 4)
// 编辑学生
export const editOneStudent = p => PUT('/studentv2/update', p, 4)
// 删除学生
export const deleteStudent = p => DELETEBODY('/studentv2/remove', p, 4)
// 根据id查询学生
export const getStudentById = p => GET('/studentv2/get', p, 4)
// 分页查询学院学生
export const getStudentListPage = p => GET('/studentv2/page', p, 4)
// 学生毕业
export const studentBatchGraduate = p => PUT('/studentv2/graduate', p, 4)

// 获取学生关联信息
export const getStudentRelecanceMessage = p => GET('/studentv2/getRelaInfo', p, 4)
// 批量删除学生
export const batchDeleteStudent = p => DELETEBODY('/studentv2/removeBatch', p, 4)
// 学生信息模板下载
export const downloadStudentInfoModel = p => download('/studentv2/studentTemplate', p, 4)
// 学生信息导入
export const importantStudentInfo = p => POSTFormData('/studentv2/importStudent', p, 4)

// 学生信息导入
export const importantStudentInfo1 = p => POSTFormData('/studentv2/basic-info/importBasicInfo', p, 4)
// 学生信息导入  新生分班学院/辅导员
export const importantStudentInfo2 = p => POSTFormData('/studentv2/basic-info/importOrientationStudent', p, 4)

// 学生信息导出
export const downloadStudentInfo = p => EXPORT('/studentv2/exportStudent', p, 4)
// 毕业导入模板下载
export const downloadStudentGraduateModel = p => download('/studentv2/graduateTemplate', p, 4)
// 毕业学生信息导入
export const importantStudentGraduateInfo = p => POSTFormData('/studentv2/importGraduate', p, 4)
//  照片批量导入
export const importPhoto = p => POSTFormDataNEW('/studentv2/photo/uploadStudentPhotos', p)



// 之前的学生接口
// 学院
//  学院分页查询
export const getStudentFacultyPage = p => POST('/studentv2/faculty/page', p, 4)
//  学院列表
export const getStudentFacultylist = p => GET('/studentv2/faculty/list', p, 4)
//  新增
export const addStudentFaculty = p => POST('/studentv2/faculty/save', p, 4)
//  编辑
export const editStudentFaculty = p => POST('/studentv2/faculty/update', p, 4)
//  删除
export const delStudentFaculty = p => POST('/studentv2/faculty/remove', p, 4)

// 专业
//  专业分页查询
export const getStudentMajorPage = p => POST('/studentv2/major/page', p, 4)
//  专业列表
export const getStudentMajorlist = p => POST('/studentv2/major/list', p, 4)
//  新增
export const addStudentMajor = p => POST('/studentv2/major/save', p, 4)
//  编辑
export const editStudentMajor = p => POST('/studentv2/major/update', p, 4)
//  删除
export const delStudentMajor = p => POST('/studentv2/major/remove', p, 4)

//  学位
//  查询列表
export const getStudentDegree = p => POST('/studentv2/degree/list', p, 4)
//  新增
export const addStudentDegree = p => POST('/studentv2/degree/save', p, 4)
//  编辑
export const editStudentDegree = p => POST('/studentv2/degree/update', p, 4)
//  删除
export const delStudentDegree = p => POST('/studentv2/degree/remove', p, 4)

//  学生
//  分页查询
export const getStudentPage = p => POST('/studentv2/page', p, 4)
//  根据id查询
//  export const getStudentById = p => POST('/studentv2/get', p, 4)
//  新增
export const addStudent = p => POST('/studentv2/save', p, 4)
//  编辑
export const editStudent = p => POST('/studentv2/update', p, 4)
//  删除
export const delStudent = p => POST('/studentv2/remove', p, 4)
//  导入
export const studentExport = p => POST('/studentv2/export', p, 4)

// 获取学生树数据
export const getStudentTree = p => POST('/studentv2/tree/list', p, 5)

//  获取  人数分配情况 数据
export const getStudentData = p => GET('/studentv2/statistics/total', p, 4)
//  获取  各学院人数 Echarts 数据
export const getFacultyNumber = p => GET('/studentv2/statistics/faculty', p, 4)
//  获取  各专业人数 Echarts 数据
export const getMajorNumber = p => GET('/studentv2/statistics/major', p, 4)
//  获取  性别比例 Echarts  数据
export const getGenderNumber = p => GET('/studentv2/statistics/gender', p, 4)
//  获取  各年级人数 Echarts 数据
export const getGradeNumber = p => GET('/studentv2/statistics/grade', p, 4)
//  获取 各民族人数 Echarts 数据
export const getNationNumber = p => GET('/studentv2/statistics/nation', p, 4)
//  上传学生图片
export const importStudentPhoto = p => POSTFormData('/studentv2/importStudentPhoto', p, 4)
//  获取辅导员信息
export const getInstructorInfo = p => GET('/studentv2/manage-permission/counselors', p)

//  新增学生页面 学生信息查询
export const addPopStudentSearch = p => GET('/studentv2/counselor-student/getByKeywords/{keywords}', p, 5)

//  添加辅导员下的学生
export const addPopStudentSubmit = p => POST('/studentv2/counselor-student/relation/add', p, 5)

//  我的学生页面 删除学生
export const InstructordelStudents = p => POST('/studentv2/counselor-student/relation/delete', p, 5)

//  根据学号姓名手机号身份证号或者学生信息
export const studentNoGetStudentInfo = p => POST('/studentv2/basic-info/findList', p, 5)

// 学生队伍管理分页数据
export const studentJobList = p => POST('/studentv2/job/studentJobList', p, 5)

// 学生队伍管理添加页分页数据
export const studentAddJobList = p => POST('/studentv2/job/studentList', p, 5)

// 添加学生职务同步到学生档案
export const saveStuJob = p => POST('/studentv2/job/saveStuJob', p, 5)

// 删除学生职务
export const deleteStudentJob = p => POST('/studentv2/job/delStuJob', p, 5)

// 修改学生职务
export const editStudentJob = p => POST('/studentv2/job/updStuJob', p, 5)

// 新生管理-统计-导入人数、应导入人数；各学院新生数量
export const getNewStudentCount = p => GETNEW('/studentv2/orientation-count/newStudentCount', p, 5)
// 新生管理-统计-学院/辅导员
export const getNewStudentCountByCounsellor = p => POSTNEW('/studentv2/orientation-count/getCountByNewStudent', p, 5)
// 老师审核表单页列表
export const auditForm = p => POST('/dataform/answer/page', p, 5)

// 审核页表单数据
export const auditFormData = p => POST('/dataform/answer/studentResult', p, 5)

// 审核数据
export const updCheckStatus = p => POST('/dataform/questionResult/updAllPass', p, 5)

// 删除表单数据
export const deleteFormData = p => DELETENEW('/dataform/answer/deleteDataForm', p, 5)

// 审核页面导出表格
export const exportFormData = p => EXPORT('/dataform/qrcode-slow/export', p, 5)
// 通用审核页面导出
export const exportFormDataList = p => EXPORT('/dataform/answer/export', p, 5)

// 获取民族列表
export const getnationList = p => GET('/studentv2/nation/list', p, 5)
// 提交老生核算记录
export const scanQrcodeByShow = p => POSTNEW('/studentv2/orientation-register/save/SHOW_QR', p, 5)
// 审核页表单数据
export const auditFormDataList = p => POST('/dataform/qrcode-slow/page', p, 5)

// 核酸检测页数据
export const nucleicList = p => POST('/studentv2/orientation-register/page-node', p, 5)

// 审核页面导出表格
export const exportnucleic = p => EXPORT('/studentv2/orientation-register/export-node', p, 5)

//  学生选号分页查询
export const studentSelectionNumber = p => POSTNEW('/studentv2/order/page', p, 5)

// 学生自主选号导出接口
export const exportStudentSelectionNumber = p => EXPORTNEW('/studentv2/order/export', p, 4)

//  军训服装分页查询
export const studentArmCloth = p => POSTNEW('/studentv2/order/findGroupPage', p, 5)

//  军训服装导出接口
export const exportStudentArmCloth = p => EXPORTNEW('/studentv2/order/exportGroup', p, 4)

// 学区在校人数统计
export const getStudentArmClothSize = p => GETNEW('/shop/sku/selectBySkuType', p, 5)


// 学生订水导出接口
export const exportStudentOrderWater = p => EXPORTNEW('/studentv2/orderWater/export', p, 4)

// 学区在校人数统计
export const getAreaInSchoolStudentCount = p => GET('/studentv2/statistics/campus', p, 5)

export const getCampus = p => POST('/basic/location/findLocationTree', p, 5)

//  获取地址
export const getArea = p => POST('/basic/area/list', p)
// 查询下载中心列表
export const getdownLoadList = p => POST('/basic/basic/exportCenter/query', p, 5)

// 删除下载记录
export const deleteDownLoad = p => POST('/basic/basic/exportCenter/removeList', p, 5)

// 查询修改记录
export const modifyRecords = p => POSTNEW('/studentv2/updateRecord/get', p, 5)

// 查询修改记录中下拉框里面值
export const getmodifyRecordsOptions = p => GETNEW('/studentv2/updateRecord/getField', p, 5)

// 查询接口
export const getModify = p => POSTNEW('/studentv2/updateRecord/get', p, 5)

//  获取配置接口(请假销假配置)
export const getFindConfig = p => GETNEW('/approval/process-config/findConfig', p, 5)

//  提交配置接口(请假销假配置)
export const updateConfig = p => POSTNEW('/approval/process-config/updateConfig', p, 5)

//  待办排序保存接口
export const backlogSortSave = p => POSTNEW('/backlog/backlog-sort/save', p, 5)

//  一键离校
export const leaveSchool = p => POSTNEW('/studentv2/basic-info/batch/leave-school', p, 5)

//  获取学年学期
export const getSchoolYear = p => GETNEW('/studentv2/calendar/get/school-year-term', p, 5)

//  审批归档
export const approvalTask = p => POSTNEW('/studentv2/data-archive/approval-task', p, 5)

//  获取合并表单列表
export const getMergeExportId = p => GETNEW('/dataform/group/findGroupList', p, 5)

//  合并导出
export const mergeExport = p => EXPORT('/dataform/group/export', p, 5)

//  学生管理和少数民族的筛选项
export const getFilterItems = p => GETNEW('/studentv2/archives-config/findQueryConfig', p, 5)

//  学生管理重置学生密码
export const resetPassword = p => POSTNEW('/studentv2/password/initialPassword', p, 5)

//  根据学号查询学生信息
export const getByStudentNo = p => GETNEW('/studentv2/basic-info/getByStudentNo', p, 5)

//  学生管理重学籍异动
export const studentAtatusChangeNEW = p => POSTNEW('/studentv2/updateStudentStatus', p, 5)

//  下载新生登记表
export const downloadNSRegistrationForm = p => GETNEW('/studentv2/basic-info/getRegisterPdf', p, 5)

//  批量下载新生登记表
export const batchDownloadNSRegistrationForm = p => POSTNEW('/studentv2/basic-info/batchDownloadPdf', p, 5)

//  获取监测对象分页
export const getPovertyDataTable = p => POSTNEW('/studentv2/familyMonitor/page', p, 5)

//  获取年级树
export const getListGradeTree = p => POSTNEW('/studentv2/listGradeTree', p, 5)

//  学生选课
//  获取学生选课计划
export const getCourseSelectionPlanTableData = p => POSTNEW('/studentgrowthfiles/courseSelectionPlan/page', p, 5)

//  生成创建计划所需scopeValue
export const generateStudentScopeValue = p => GETNEW('/studentgrowthfiles/planApplyName/guidd', p, 5)

//  获取创建计划步骤
export const getStudentCreatePlanSteps = p => GETNEW('/studentgrowthfiles/plan-basic/config-define/findListByClassId', p, 5)

//  获取导入学生列表
export const getImportStudentTableList = p => POSTNEW('/studentgrowthfiles/planApplyName/pageStudent', p, 5)

//  计划学生列表导入提交
export const courseSelectionStudentSubmitImport = p => POSTFormDataNEW('/studentgrowthfiles/planApplyName/importNameList', p)

//  计划学生列表批量新增
export const batchAddStudentList = p => POSTNEW('/studentgrowthfiles/planApplyName/saveByScopeValue', p, 5)

//  计划学生列表批量删除
export const batchDelStudentList = p => POSTNEW('/studentgrowthfiles/planApplyName/removeList', p, 5)

//  计划学生列表全量新增
export const quantityAddStudentList = p => POSTNEW('/studentgrowthfiles/planApplyName/saveBySelect', p, 5)

//  计划学生列表全量删除
export const quantityDelStudentList = p => POSTNEW('/studentgrowthfiles/planApplyName/deleteByScopeValue', p, 5)

//  创建学生选课计划
export const createCourseSelectionPlan = p => POSTNEW('/studentgrowthfiles/courseSelectionPlan/insertOrUpdateInfo', p, 5)

//  编辑学生选课计划
export const editCourseSelectionPlan = p => GETNEW('/studentgrowthfiles/courseSelectionPlan/detailById', p, 5)

//  获取学生选课详情列表
export const getCourseSelectionDetailTableData = p => POSTNEW('/studentgrowthfiles/courseSelection/page/{courseType}', p, 5)

//  获取学生选课统计数据
export const getCourseSelectionDetailStatic = p => GETNEW('/studentgrowthfiles/courseSelection/courseCount', p, 5)

//  导出学生选课数据
export const exportCourseSelectionData = p => EXPORTNEW('/studentgrowthfiles/courseSelection/export/{courseType}', p, 4)

//  完成学生选课计划
export const finishCourseSelectionPlan = p => POSTNEW('/studentgrowthfiles/plan/config/finish', p, 4)

//  撤销学生选课
export const  revokeStudentCourseSelection  = p => POSTNEW('/studentgrowthfiles/courseSelectionApply/revokeById', p, 4)




// WEBPACK FOOTER //
// ./src/api/modules/student.js